// import React, { useState, useEffect, useCallback, useRef } from "react";
// import { message as antMessage } from "antd";
// import { getAccessToken } from "../../token";
// import { API_URL } from "../../Constants";

// // ─── Utility Functions ──────────────────────────────────────────────────────── 

// const formatDate = (dateInput) => {
//   if (!dateInput) return "—";
//   if (Array.isArray(dateInput)) {
//     const [year, month, day, hour = 0, minute = 0, second = 0] = dateInput;
//     return new Date(year, month - 1, day, hour, minute, second).toLocaleString("en-US", {
//       month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true,
//     });
//   }
//   return new Date(dateInput).toLocaleString("en-US", {
//     month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true,
//   });
// };

// const formatCurrency = (amount) => {
//   if (amount === undefined || amount === null) return "0.00";
//   return new Intl.NumberFormat("en-IN", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(amount / 1000);
// };

// // ─── Icons ──────────────────────────────────────────────────────────────────── 

// const Icon = {
//   Search: () => (
//     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
//     </svg>
//   ),
//   Filter: () => (
//     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
//     </svg>
//   ),
//   ChevronLeft: () => (
//     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="15 18 9 12 15 6" />
//     </svg>
//   ),
//   ChevronRight: () => (
//     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="9 18 15 12 9 6" />
//     </svg>
//   ),
//   Refresh: ({ spinning }) => (
//     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
//       style={{ animation: spinning ? "spin 0.8s linear infinite" : "none" }}>
//       <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" />
//       <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
//     </svg>
//   ),
//   Eye: () => (
//     <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
//     </svg>
//   ),
//   Close: () => (
//     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
//     </svg>
//   ),
//   Copy: () => (
//     <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
//       <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
//     </svg>
//   ),
//   Check: () => (
//     <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="20 6 9 17 4 12" />
//     </svg>
//   ),
//   Inbox: () => (
//     <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//       <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
//       <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
//     </svg>
//   ),
//   Message: () => (
//     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
//     </svg>
//   ),
//   Zap: () => (
//     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
//     </svg>
//   ),
// };

// // ─── Status Badge ───────────────────────────────────────────────────────────── 

// const STATUS_CONFIG = {
//   DELIVERED: { bg: "#d1fae5", text: "#065f46", dot: "#10b981", label: "Delivered" },
//   UNDELIVERED: { bg: "#fee2e2", text: "#991b1b", dot: "#ef4444", label: "Undelivered" },
//   REJECTED: { bg: "#fee2e2", text: "#991b1b", dot: "#ef4444", label: "Rejected" },
//   FAILED: { bg: "#fee2e2", text: "#991b1b", dot: "#ef4444", label: "Failed" },
//   EXPIRED: { bg: "#ffedd5", text: "#9a3412", dot: "#f97316", label: "Expired" },
//   QUEUED: { bg: "#f1f5f9", text: "#475569", dot: "#94a3b8", label: "Queued" },
//   SUBMITTED: { bg: "#dbeafe", text: "#1e40af", dot: "#3b82f6", label: "Submitted" },
// };

// const StatusBadge = ({ status }) => {
//   const key = status ? status.toUpperCase() : "UNKNOWN";
//   const cfg = STATUS_CONFIG[key] || { bg: "#f3f4f6", text: "#4b5563", dot: "#9ca3af", label: key };
//   return (
//     <span style={{
//       display: "inline-flex", alignItems: "center", gap: "5px",
//       padding: "3px 9px", borderRadius: "999px", fontSize: "11px", fontWeight: 700,
//       letterSpacing: "0.04em", background: cfg.bg, color: cfg.text,
//       fontFamily: "'DM Sans', sans-serif",
//     }}>
//       <span style={{ width: 6, height: 6, borderRadius: "50%", background: cfg.dot, flexShrink: 0 }} />
//       {cfg.label}
//     </span>
//   );
// };

// // ─── Skeleton Rows ──────────────────────────────────────────────────────────── 

// const SkeletonRow = ({ delay = 0 }) => (
//   <tr style={{ borderBottom: "1px solid #f1f5f9", animation: `fadeIn 0.4s ease ${delay}ms both` }}>
//     {[28, 36, 24, 52, 22, 16, 20, 20].map((w, i) => (
//       <td key={i} style={{ padding: "14px 20px" }}>
//         <div style={{
//           height: 11, width: `${w * 4}px`, maxWidth: "100%",
//           background: "linear-gradient(90deg, #f1f5f9 25%, #e8edf2 50%, #f1f5f9 75%)",
//           backgroundSize: "200% 100%", borderRadius: 6,
//           animation: "shimmer 1.6s infinite",
//         }} />
//       </td>
//     ))}
//   </tr>
// );

// // ─── Message Modal ──────────────────────────────────────────────────────────── 

// const MessageModal = ({ message, onClose }) => {
//   useEffect(() => {
//     const handler = (e) => e.key === "Escape" && onClose();
//     window.addEventListener("keydown", handler);
//     return () => window.removeEventListener("keydown", handler);
//   }, [onClose]);

//   if (!message) return null;
//   return (
//     <div
//       onClick={onClose}
//       style={{
//         position: "fixed", inset: 0, zIndex: 1000,
//         background: "rgba(15,23,42,0.5)", backdropFilter: "blur(6px)",
//         display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
//         animation: "fadeIn 0.15s ease",
//       }}
//     >
//       <div
//         onClick={(e) => e.stopPropagation()}
//         style={{
//           background: "#F0EFEB", borderRadius: 20, boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
//           width: "100%", maxWidth: 520, overflow: "hidden",
//           animation: "modalIn 0.2s cubic-bezier(0.34,1.56,0.64,1)",
//         }}
//       >
//         <div style={{
//           padding: "18px 24px", borderBottom: "1px solid #f1f5f9",
//           display: "flex", alignItems: "center", justifyContent: "space-between",
//           background: "#0C4550",
//         }}>
//           <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//             <div style={{
//               width: 32, height: 32, borderRadius: 10, background: "#e0f2fe",
//               display: "flex", alignItems: "center", justifyContent: "center", color: "#0369a1",
//             }}>
//               <Icon.Message />
//             </div>
//             <span style={{ fontWeight: 700, fontSize: 15, color: "#ffffff", fontFamily: "'DM Sans', sans-serif" }}>
//               Message Content
//             </span>
//           </div>
//           <button
//             onClick={onClose}
//             style={{
//               border: "none",
//               background: "transparent",
//               cursor: "pointer",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "#fff",
//               padding: 0,
//               outline: "none",
//             }}
//           >
//             <Icon.Close />
//           </button>
//         </div>
//         <div style={{ padding: 24 }}>
//           <div style={{
//             background: "#f8fafc", borderRadius: 12, border: "1px solid #e2e8f0",
//             padding: "16px 20px", color: "#334155", fontSize: 14, lineHeight: 1.7,
//             whiteSpace: "pre-wrap", fontFamily: "ui-monospace, 'Cascadia Code', monospace",
//             minHeight: 80,
//           }}>
//             {message}
//           </div>
//           <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
//             <button
//               onClick={() => { navigator.clipboard.writeText(message); antMessage.success("Copied!"); }}
//               style={{
//                 display: "flex", alignItems: "center", gap: 6,
//                 padding: "8px 16px", borderRadius: 8, border: "1px solid #e2e8f0",
//                 background: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600,
//                 color: "#475569", fontFamily: "'DM Sans', sans-serif", transition: "all 0.15s",
//               }}
//               onMouseEnter={(e) => { e.currentTarget.style.background = "#f8fafc"; e.currentTarget.style.borderColor = "#cbd5e1"; }}
//               onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.borderColor = "#e2e8f0"; }}
//             >
//               <Icon.Copy /> Copy
//             </button>
//             <button
//               onClick={onClose}
//               style={{
//                 padding: "8px 20px", borderRadius: 8, border: "none",
//                 background: "#0c4550", cursor: "pointer", fontSize: 13, fontWeight: 700,
//                 color: "#fff", fontFamily: "'DM Sans', sans-serif", transition: "all 0.15s",
//               }}
//               onMouseEnter={(e) => e.currentTarget.style.background = "#093840"}
//               onMouseLeave={(e) => e.currentTarget.style.background = "#0c4550"}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// // ─── Copy Button ────────────────────────────────────────────────────────────── 

// const CopyButton = ({ text }) => {
//   const [copied, setCopied] = useState(false);
//   const handle = () => {
//     navigator.clipboard.writeText(text);
//     setCopied(true);
//     antMessage.success("Copied!");
//     setTimeout(() => setCopied(false), 2000);
//   };
//   return (
//     <button
//       onClick={handle}
//       title="Copy"
//       style={{
//         border: "none", background: "transparent", cursor: "pointer",
//         color: copied ? "#10b981" : "#cbd5e1", transition: "color 0.2s",
//         padding: 2, display: "flex", alignItems: "center",
//       }}
//       onMouseEnter={(e) => { if (!copied) e.currentTarget.style.color = "#0ea5e9"; }}
//       onMouseLeave={(e) => { if (!copied) e.currentTarget.style.color = "#cbd5e1"; }}
//     >
//       {copied ? <Icon.Check /> : <Icon.Copy />}
//     </button>
//   );
// };

// // ─── Pagination ─────────────────────────────────────────────────────────────── 

// const Pagination = ({ page, totalPages, totalItems, pageSize, onPage }) => {
//   const from = totalItems === 0 ? 0 : page * pageSize + 1;
//   const to = Math.min((page + 1) * pageSize, totalItems);

//   const pages = [];
//   const range = (lo, hi) => { for (let i = lo; i <= hi; i++) pages.push(i); };
//   if (totalPages <= 7) {
//     range(0, totalPages - 1);
//   } else if (page < 4) {
//     range(0, 4); pages.push("…"); pages.push(totalPages - 1);
//   } else if (page > totalPages - 5) {
//     pages.push(0); pages.push("…"); range(totalPages - 5, totalPages - 1);
//   } else {
//     pages.push(0); pages.push("…"); range(page - 1, page + 1); pages.push("…"); pages.push(totalPages - 1);
//   }

//   const btnBase = {
//     minWidth: 34, height: 34, borderRadius: 8, border: "1px solid #e2e8f0",
//     background: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600,
//     color: "#64748b", transition: "all 0.15s", display: "flex",
//     alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', sans-serif",
//     padding: "0 8px",
//   };

//   return (
//     <div style={{
//       padding: "14px 20px", borderTop: "1px solid #f1f5f9", background: "#fafafa",
//       display: "flex", alignItems: "center", justifyContent: "space-between",
//       flexWrap: "wrap", gap: 12,
//     }}>
//       <span style={{ fontSize: 13, color: "#64748b", fontFamily: "'DM Sans', sans-serif" }}>
//         Showing <strong style={{ color: "#0f172a" }}>{from}</strong>–<strong style={{ color: "#0f172a" }}>{to}</strong> of{" "}
//         <strong style={{ color: "#0f172a" }}>{totalItems.toLocaleString()}</strong> records
//       </span>
//       <div style={{ display: "flex", gap: 4 }}>
//         <button
//           onClick={() => onPage(page - 1)} disabled={page === 0}
//           style={{ ...btnBase, opacity: page === 0 ? 0.4 : 1, cursor: page === 0 ? "not-allowed" : "pointer" }}
//           onMouseEnter={(e) => { if (page !== 0) e.currentTarget.style.background = "#f8fafc"; }}
//           onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}
//         >
//           <Icon.ChevronLeft />
//         </button>
//         {pages.map((p, i) =>
//           p === "…" ? (
//             <span key={`e${i}`} style={{ ...btnBase, border: "none", background: "transparent", cursor: "default" }}>…</span>
//           ) : (
//             <button
//               key={p} onClick={() => onPage(p)}
//               style={{
//                 ...btnBase,
//                 background: p === page ? "#0c4550" : "#fff",
//                 color: p === page ? "#fff" : "#64748b",
//                 borderColor: p === page ? "#0c4550" : "#e2e8f0",
//               }}
//               onMouseEnter={(e) => { if (p !== page) e.currentTarget.style.background = "#f8fafc"; }}
//               onMouseLeave={(e) => { if (p !== page) e.currentTarget.style.background = "#fff"; }}
//             >
//               {p + 1}
//             </button>
//           )
//         )}
//         <button
//           onClick={() => onPage(page + 1)} disabled={page >= totalPages - 1 || totalPages === 0}
//           style={{ ...btnBase, opacity: (page >= totalPages - 1 || totalPages === 0) ? 0.4 : 1, cursor: (page >= totalPages - 1 || totalPages === 0) ? "not-allowed" : "pointer" }}
//           onMouseEnter={(e) => { if (!(page >= totalPages - 1 || totalPages === 0)) e.currentTarget.style.background = "#f8fafc"; }}
//           onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}
//         >
//           <Icon.ChevronRight />
//         </button>
//       </div>
//     </div>
//   );
// };

// // ─── Main Component ─────────────────────────────────────────────────────────── 

// export const SmsReports = () => {
//   const token = getAccessToken();

//   const [logs, setLogs] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [firstLoad, setFirstLoad] = useState(true);
//   const [viewMessage, setViewMessage] = useState(null);
//   const [reportType, setReportType] = useState("single");
//   const [page, setPage] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [totalItems, setTotalItems] = useState(0);
//   const pageSize = 20;
//   const KEYSET_THRESHOLD = 200;
//   const lastSentAtCursor = useRef(null);

//   const [filters, setFilters] = useState({
//     mobile: "", senderId: "", status: "", startDate: "", endDate: "",
//   });
//   const pendingFilters = useRef({ ...filters });

//   // ── Fetch ────────────────────────────────────────────────────────────────── 

//   const fetchReports = useCallback(async (opts = {}) => {
//     setLoading(true);
//     const activeFilters = opts.filters || pendingFilters.current;
//     const activePage = opts.page !== undefined ? opts.page : page;

//     try {
//       const params = new URLSearchParams({ page: activePage, size: pageSize });
//       if (activeFilters.mobile) params.set("mobile", activeFilters.mobile);
//       if (activeFilters.senderId) params.set("senderId", activeFilters.senderId);
//       if (activeFilters.status) params.set("status", activeFilters.status);
//       if (activeFilters.startDate) params.set("startDate", activeFilters.startDate);
//       if (activeFilters.endDate) params.set("endDate", activeFilters.endDate);

//       if (activePage >= KEYSET_THRESHOLD && lastSentAtCursor.current) {
//         params.set("lastSentAt", lastSentAtCursor.current);
//       }

//       const endpoint = reportType === "single"
//         ? `/api/reports/single`
//         : `/api/reports/bulk`;

//       const res = await fetch(`${API_URL}${endpoint}?${params}`, {
//         headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
//       });

//       if (!res.ok) throw new Error(`HTTP ${res.status}`);
//       const data = await res.json();

//       const records = data.content ?? [];
//       setLogs(records);
//       setTotalPages(data.totalPages ?? 0);
//       setTotalItems(data.totalElements ?? 0);

//       if (records.length > 0) {
//         const last = records[records.length - 1];
//         lastSentAtCursor.current = Array.isArray(last.submittedAt)
//           ? new Date(...last.submittedAt.map((v, i) => i === 1 ? v - 1 : v)).toISOString()
//           : last.submittedAt;
//       }
//     } catch (err) {
//       antMessage.error(`Could not load ${reportType} reports. Please try again.`);
//       setLogs([]);
//     } finally {
//       setLoading(false);
//       setFirstLoad(false);
//     }
//   }, [reportType, page, token]);

//   useEffect(() => { fetchReports(); }, [page, reportType]);

//   // ── Handlers ─────────────────────────────────────────────────────────────── 

//   const handleTabChange = (type) => {
//     if (type === reportType) return;
//     lastSentAtCursor.current = null;
//     setReportType(type);
//     setPage(0);
//     setLogs([]);
//     setFirstLoad(true);
//   };

//   const handleFilterChange = (e) => {
//     const next = { ...pendingFilters.current, [e.target.name]: e.target.value };
//     pendingFilters.current = next;
//     setFilters(next);
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     lastSentAtCursor.current = null;
//     setPage(0);
//     fetchReports({ page: 0, filters: pendingFilters.current });
//   };

//   const handleClearFilters = () => {
//     const empty = { mobile: "", senderId: "", status: "", startDate: "", endDate: "" };
//     pendingFilters.current = empty;
//     lastSentAtCursor.current = null;
//     setFilters(empty);
//     setPage(0);
//     fetchReports({ page: 0, filters: empty });
//   };

//   const hasActiveFilters = Object.values(filters).some(Boolean);

//   // ── Styles ───────────────────────────────────────────────────────────────── 

//   const inputStyle = {
//     width: "100%", height: 40, padding: "0 12px", fontSize: 13,
//     border: "1px solid #e2e8f0", borderRadius: 10, background: "#fff",
//     color: "#334155", outline: "none", fontFamily: "'DM Sans', sans-serif",
//     boxSizing: "border-box", transition: "border-color 0.15s, box-shadow 0.15s",
//   };

//   const labelStyle = {
//     fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.07em",
//     textTransform: "uppercase", marginBottom: 5, display: "block",
//     fontFamily: "'DM Sans', sans-serif",
//   };

//   // ── Render ───────────────────────────────────────────────────────────────── 

//   return (
//     <>
//       <style>{` 
//         @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&display=swap'); 
//         @keyframes fadeIn { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } } 
//         @keyframes modalIn { from { opacity:0; transform:scale(0.94) translateY(10px); } to { opacity:1; transform:scale(1) translateY(0); } } 
//         @keyframes spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } } 
//         @keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} } 
//         @keyframes slideIn { from { opacity:0; transform:translateX(-8px); } to { opacity:1; transform:translateX(0); } } 
//         .report-row { transition: background 0.12s; } 
//         .report-row:hover { background: #f0f9ff !important; } 
//         .report-row:hover .eye-btn { opacity: 1 !important; } 
//         .report-row:hover .copy-zone { opacity: 1 !important; } 
//         .filter-input:focus { border-color: #0c4550 !important; box-shadow: 0 0 0 3px rgba(12,69,80,0.08) !important; } 
//         .filter-input:hover { border-color: #94a3b8 !important; } 
//         select.filter-input { appearance: none; cursor: pointer; } 
//       `}</style>

//       <div style={{
//         minHeight: "100vh", background: "#f0efeb", padding: "28px 24px",
//         fontFamily: "'DM Sans', sans-serif",
//       }}>
//         <div style={{ maxWidth: 1400, margin: "0 auto" }}>

//           {/* ── Header ── */}
//           <div style={{
//             display: "flex", justifyContent: "space-between", alignItems: "flex-start",
//             flexWrap: "wrap", gap: 16, marginBottom: 24,
//             animation: "fadeIn 0.4s ease",
//           }}>
//             <div>
//               <h1 style={{
//                 fontSize: 26, fontWeight: 700, color: "#0f172a", margin: 0,
//                 letterSpacing: "-0.02em",
//               }}>
//                 Delivery Reports
//               </h1>
//               <p style={{ margin: "4px 0 0", fontSize: 14, color: "#64748b" }}>
//                 Track and analyze your SMS delivery performance
//               </p>
//             </div>

//             <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
//               {/* Tab Toggle - Matches Reference Design with Icons & Custom Names */}
//               <div style={{
//                 display: "flex", gap: "8px", background: "rgba(255, 255, 255, 0.6)",
//                 padding: "6px", borderRadius: "12px", border: "1px solid #fff",
//                 boxShadow: "0 1px 2px rgba(0,0,0,0.05)", width: "fit-content"
//               }}>
//                 {[
//                   { key: "single", label: "Single Messages", icon: <Icon.Message /> },
//                   { key: "bulk", label: "Bulk Messages", icon: <Icon.Zap /> },
//                 ].map(({ key, label, icon }) => {
//                   const active = reportType === key;
//                   return (
//                     <button
//                       key={key}
//                       onClick={() => handleTabChange(key)}
//                       style={{
//                         display: "flex", alignItems: "center", gap: "8px",
//                         padding: "8px 20px", borderRadius: "8px", border: "none", cursor: "pointer",
//                         fontSize: "14px", fontWeight: 700, fontFamily: "'DM Sans', sans-serif",
//                         transition: "all 0.3s ease",
//                         background: active ? "#0C4550" : "transparent",
//                         color: active ? "#fff" : "#0C4550",
//                         boxShadow: active ? "0 4px 6px rgba(0,0,0,0.1)" : "none",
//                       }}
//                       onMouseEnter={(e) => {
//                         if (!active) {
//                           e.currentTarget.style.background = "rgba(12, 69, 80, 0.1)";
//                         }
//                       }}
//                       onMouseLeave={(e) => {
//                         if (!active) {
//                           e.currentTarget.style.background = "transparent";
//                         }
//                       }}
//                     >
//                       <span style={{ display: "flex", alignItems: "center" }}>{icon}</span>
//                       {label}
//                     </button>
//                   );
//                 })}
//               </div>

//               {/* Refresh */}
//               <button
//                 onClick={() => fetchReports()}
//                 title="Refresh"
//                 style={{
//                   width: 38, height: 38, borderRadius: 10, border: "1px solid #e2e8f0",
//                   background: "#fff", cursor: "pointer", display: "flex", alignItems: "center",
//                   justifyContent: "center", color: loading ? "#0c4550" : "#64748b",
//                   transition: "all 0.15s", flexShrink: 0,
//                 }}
//                 onMouseEnter={(e) => { e.currentTarget.style.background = "#f8fafc"; e.currentTarget.style.borderColor = "#cbd5e1"; }}
//                 onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.borderColor = "#e2e8f0"; }}
//               >
//                 <Icon.Refresh spinning={loading} />
//               </button>
//             </div>
//           </div>

//           {/* ── Filters Panel ── */}
//           <div style={{
//             background: "#fff", borderRadius: 16, border: "1px solid #e8e6e0",
//             padding: "18px 20px", marginBottom: 20,
//             animation: "fadeIn 0.4s ease 0.05s both",
//           }}>
//             <div style={{
//               display: "flex", alignItems: "center", justifyContent: "space-between",
//               marginBottom: 14, paddingBottom: 12, borderBottom: "1px solid #f8fafc",
//             }}>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <div style={{
//                   width: 28, height: 28, borderRadius: 8, background: "#e0f2f9",
//                   display: "flex", alignItems: "center", justifyContent: "center", color: "#0c4550",
//                 }}>
//                   <Icon.Filter />
//                 </div>
//                 <span style={{ fontWeight: 700, fontSize: 12, color: "#475569", letterSpacing: "0.07em", textTransform: "uppercase" }}>
//                   Filter {reportType === "single" ? "Single" : "Bulk"} Records
//                 </span>
//               </div>
//               {hasActiveFilters && (
//                 <button
//                   onClick={handleClearFilters}
//                   style={{
//                     fontSize: 12, fontWeight: 600, color: "#94a3b8", background: "none",
//                     border: "none", cursor: "pointer", display: "flex", alignItems: "center",
//                     gap: 4, padding: "3px 8px", borderRadius: 6, transition: "all 0.15s",
//                     fontFamily: "'DM Sans', sans-serif",
//                   }}
//                   onMouseEnter={(e) => { e.currentTarget.style.color = "#ef4444"; e.currentTarget.style.background = "#fef2f2"; }}
//                   onMouseLeave={(e) => { e.currentTarget.style.color = "#94a3b8"; e.currentTarget.style.background = "none"; }}
//                 >
//                   <Icon.Close /> Clear filters
//                 </button>
//               )}
//             </div>

//             <form onSubmit={handleSearch}>
//               <div style={{
//                 display: "grid",
//                 gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
//                 gap: 14, alignItems: "end",
//               }}>
//                 {/* 1. Delivery Status */}
//                 <div style={{ position: "relative" }}>
//                   <label style={labelStyle}>Delivery Status</label>
//                   <div style={{ position: "relative" }}>
//                     <select
//                       name="status" value={filters.status} onChange={handleFilterChange}
//                       className="filter-input" style={{ ...inputStyle, paddingRight: 30 }}
//                       onFocus={(e) => { e.target.style.borderColor = "#0c4550"; e.target.style.boxShadow = "0 0 0 3px rgba(12,69,80,0.08)"; }}
//                       onBlur={(e) => { e.target.style.borderColor = "#e2e8f0"; e.target.style.boxShadow = "none"; }}
//                     >
//                       <option value="">All Statuses</option>
//                       <option value="DELIVERED">Delivered</option>
//                       <option value="UNDELIVERED">Undelivered</option>
//                       <option value="FAILED">Failed</option>
//                     </select>
//                     <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", pointerEvents: "none" }}>
//                       <Icon.ChevronRight />
//                     </span>
//                   </div>
//                 </div>

//                 {/* 2. Mobile Number */}
//                 <div style={{ position: "relative" }}>
//                   <label style={labelStyle}>Mobile Number</label>
//                   <div style={{ position: "relative" }}>
//                     <span style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", pointerEvents: "none", display: "flex" }}>
//                       <Icon.Search />
//                     </span>
//                     <input
//                       type="text" name="mobile" placeholder="e.g. 9876543210"
//                       value={filters.mobile} onChange={handleFilterChange}
//                       className="filter-input"
//                       style={{ ...inputStyle, paddingLeft: 34 }}
//                       onFocus={(e) => { e.target.style.borderColor = "#0c4550"; e.target.style.boxShadow = "0 0 0 3px rgba(12,69,80,0.08)"; }}
//                       onBlur={(e) => { e.target.style.borderColor = "#e2e8f0"; e.target.style.boxShadow = "none"; }}
//                     />
//                   </div>
//                 </div>

//                 {/* 3. Sender ID */}
//                 <div>
//                   <label style={labelStyle}>Sender ID</label>
//                   <input
//                     type="text" name="senderId" placeholder="e.g. ALERTS"
//                     value={filters.senderId} onChange={handleFilterChange}
//                     className="filter-input" style={inputStyle}
//                     onFocus={(e) => { e.target.style.borderColor = "#0c4550"; e.target.style.boxShadow = "0 0 0 3px rgba(12,69,80,0.08)"; }}
//                     onBlur={(e) => { e.target.style.borderColor = "#e2e8f0"; e.target.style.boxShadow = "none"; }}
//                   />
//                 </div>

//                 {/* 4. Date Range */}
//                 <div style={{ gridColumn: "span 2", minWidth: 0 }}>
//                   <label style={labelStyle}>Date Range</label>
//                   <div style={{
//                     display: "flex", alignItems: "center", gap: 6,
//                     height: 40, border: "1px solid #e2e8f0", borderRadius: 10,
//                     background: "#fff", overflow: "hidden", padding: "0 4px",
//                     transition: "border-color 0.15s", boxSizing: "border-box",
//                   }}
//                     onFocusCapture={(e) => e.currentTarget.style.borderColor = "#0c4550"}
//                     onBlurCapture={(e) => e.currentTarget.style.borderColor = "#e2e8f0"}
//                   >
//                     <input type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange}
//                       style={{ flex: 1, border: "none", outline: "none", fontSize: 12, color: "#334155", background: "transparent", fontFamily: "'DM Sans', sans-serif", minWidth: 0 }} />
//                     <span style={{ color: "#cbd5e1", fontSize: 11, fontWeight: 600, flexShrink: 0 }}>to</span>
//                     <input type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange}
//                       style={{ flex: 1, border: "none", outline: "none", fontSize: 12, color: "#334155", background: "transparent", fontFamily: "'DM Sans', sans-serif", minWidth: 0 }} />
//                   </div>
//                 </div>

//                 {/* 5. Apply */}
//                 <div>
//                   <button
//                     type="submit" disabled={loading}
//                     style={{
//                       width: "100%", height: 40, border: "none", borderRadius: 10,
//                       background: loading ? "#94a3b8" : "#0c4550", color: "#fff",
//                       fontSize: 13, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
//                       fontFamily: "'DM Sans', sans-serif", transition: "all 0.15s",
//                       display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
//                     }}
//                     onMouseEnter={(e) => { if (!loading) e.currentTarget.style.background = "#093840"; }}
//                     onMouseLeave={(e) => { if (!loading) e.currentTarget.style.background = "#0c4550"; }}
//                   >
//                     {loading
//                       ? <div style={{ width: 14, height: 14, borderRadius: "50%", border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#fff", animation: "spin 0.7s linear infinite" }} />
//                       : <><Icon.Search /> Apply</>
//                     }
//                   </button>
//                 </div>
//               </div>
//             </form>
//           </div>

//           {/* ── Table Card ── */}
//           <div style={{
//             background: "#fff", borderRadius: 16, border: "1px solid #e8e6e0",
//             overflow: "hidden", animation: "fadeIn 0.4s ease 0.1s both",
//           }}>
//             <div style={{
//               padding: "14px 20px 12px", borderBottom: "1px solid #f1f5f9",
//               display: "flex", alignItems: "center", justifyContent: "space-between",
//             }}>
//               <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                 <span style={{
//                   display: "inline-flex", alignItems: "center", gap: 5,
//                   padding: "3px 10px", borderRadius: 999, fontSize: 11, fontWeight: 700,
//                   background: reportType === "single" ? "#e0f2fe" : "#fef9c3",
//                   color: reportType === "single" ? "#0369a1" : "#854d0e",
//                 }}>
//                   <span style={{
//                     width: 6, height: 6, borderRadius: "50%",
//                     background: reportType === "single" ? "#0ea5e9" : "#eab308",
//                   }} />
//                   {reportType === "single" ? "Single Messages" : "Bulk Messages"}
//                 </span>
//                 {!loading && (
//                   <span style={{ fontSize: 12, color: "#94a3b8", fontWeight: 500 }}>
//                     {totalItems.toLocaleString()} records
//                   </span>
//                 )}
//               </div>
//             </div>

//             <div style={{ overflowX: "auto" }}>
//               <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 840 }}>
//                 <thead>
//                   <tr style={{ background: "#f8fafc", borderBottom: "1px solid #f1f5f9" }}>
//                     {["Submitted At", "Message ID", "Recipient", "Content", "Status", "Cost (₹)", "Refund (₹)"].map((h, i) => (
//                       <th key={h} style={{
//                         padding: "11px 20px", textAlign: (i >= 5) ? "right" : "left",
//                         fontSize: 11, fontWeight: 700, color: "#94a3b8",
//                         letterSpacing: "0.07em", textTransform: "uppercase",
//                         whiteSpace: "nowrap", fontFamily: "'DM Sans', sans-serif",
//                       }}>
//                         {h}
//                       </th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loading ? (
//                     [...Array(8)].map((_, i) => <SkeletonRow key={i} delay={i * 40} />)
//                   ) : logs.length === 0 ? (
//                     <tr>
//                       <td colSpan={7} style={{ padding: "72px 20px", textAlign: "center" }}>
//                         <div style={{
//                           width: 64, height: 64, borderRadius: "50%", background: "#f1f5f9",
//                           display: "flex", alignItems: "center", justifyContent: "center",
//                           margin: "0 auto 16px", color: "#cbd5e1",
//                         }}>
//                           <Icon.Inbox />
//                         </div>
//                         <p style={{ fontWeight: 700, fontSize: 16, color: "#334155", margin: "0 0 4px" }}>
//                           No records found
//                         </p>
//                         <p style={{ fontSize: 13, color: "#94a3b8", margin: 0 }}>
//                           {hasActiveFilters ? "Try adjusting your filters." : "No messages to show yet."}
//                         </p>
//                       </td>
//                     </tr>
//                   ) : (
//                     logs.map((log, idx) => (
//                       <tr
//                         key={log.messageId || idx}
//                         className="report-row"
//                         style={{
//                           borderBottom: "1px solid #f8fafc",
//                           animation: `slideIn 0.25s ease ${Math.min(idx, 10) * 30}ms both`,
//                         }}
//                       >
//                         <td style={{ padding: "13px 20px", whiteSpace: "nowrap" }}>
//                           <span style={{ fontSize: 12, color: "#64748b", fontWeight: 500 }}>
//                             {formatDate(log.submittedAt)}
//                           </span>
//                         </td>
//                         <td style={{ padding: "13px 20px" }}>
//                           <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
//                             <span style={{
//                               fontSize: 11, fontFamily: "ui-monospace, monospace",
//                               background: "#f8fafc", border: "1px solid #e2e8f0",
//                               borderRadius: 6, padding: "3px 7px", color: "#475569",
//                               maxWidth: 110, overflow: "hidden", textOverflow: "ellipsis",
//                               whiteSpace: "nowrap", display: "block",
//                             }} title={log.messageId}>
//                               {log.messageId || "—"}
//                             </span>
//                             {log.messageId && (
//                               <span className="copy-zone" style={{ opacity: 0, transition: "opacity 0.15s" }}>
//                                 <CopyButton text={log.messageId} />
//                               </span>
//                             )}
//                           </div>
//                         </td>
//                         <td style={{ padding: "13px 20px", whiteSpace: "nowrap" }}>
//                           <span style={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}>
//                             {log.recipient || "—"}
//                           </span>
//                         </td>
//                         <td style={{ padding: "13px 20px", maxWidth: 260 }}>
//                           <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//                             <span style={{
//                               fontSize: 13, color: "#475569", overflow: "hidden",
//                               textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1,
//                               minWidth: 0,
//                             }} title={log.content}>
//                               {log.content || <span style={{ color: "#cbd5e1" }}>—</span>}
//                             </span>
//                             {log.content && (
//                               <button
//                                 className="eye-btn"
//                                 onClick={() => setViewMessage(log.content)}
//                                 title="View full message"
//                                 style={{
//                                   opacity: 0, transition: "opacity 0.15s",
//                                   border: "1px solid #e2e8f0", borderRadius: 7, background: "#fff",
//                                   width: 26, height: 26, display: "flex", alignItems: "center",
//                                   justifyContent: "center", cursor: "pointer", flexShrink: 0,
//                                   color: "#64748b",
//                                 }}
//                                 onMouseEnter={(e) => { e.currentTarget.style.background = "#e0f2fe"; e.currentTarget.style.color = "#0369a1"; e.currentTarget.style.borderColor = "#bae6fd"; }}
//                                 onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.color = "#64748b"; e.currentTarget.style.borderColor = "#e2e8f0"; }}
//                               >
//                                 <Icon.Eye />
//                               </button>
//                             )}
//                           </div>
//                         </td>
//                         <td style={{ padding: "13px 20px", whiteSpace: "nowrap" }}>
//                           <StatusBadge status={log.detailedStatus} />
//                         </td>
//                         {/* <td style={{ padding: "13px 20px", whiteSpace: "nowrap" }}>
//                           {log.errorCode
//                             ? <span style={{ fontSize: 11, fontFamily: "ui-monospace, monospace", color: "#ef4444", background: "#fef2f2", padding: "2px 6px", borderRadius: 5, border: "1px solid #fecaca" }}>
//                               {log.errorCode}
//                             </span>
//                             : <span style={{ color: "#e2e8f0", fontSize: 12 }}>—</span>
//                           }
//                         </td> */}
//                         <td style={{ padding: "13px 20px", textAlign: "right", whiteSpace: "nowrap" }}>
//                           <span style={{ fontSize: 13, fontFamily: "ui-monospace, monospace", color: "#334155", fontWeight: 600 }}>
//                             {formatCurrency(log.cost)}
//                           </span>
//                         </td>
//                         <td style={{ padding: "13px 20px", textAlign: "right", whiteSpace: "nowrap" }}>
//                           {log.refundedAmount > 0 ? (
//                             <span style={{ fontSize: 13, fontFamily: "ui-monospace, monospace", color: "#10b981", fontWeight: 700 }}>
//                               +{formatCurrency(log.refundedAmount)}
//                             </span>
//                           ) : (
//                             <span style={{ fontSize: 13, fontFamily: "ui-monospace, monospace", color: "#94a3b8" }}>
//                               {formatCurrency(0)}
//                             </span>
//                           )}
//                         </td>
//                       </tr>
//                     ))
//                   )}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             {!loading && totalPages > 0 && (
//               <Pagination
//                 page={page}
//                 totalPages={totalPages}
//                 totalItems={totalItems}
//                 pageSize={pageSize}
//                 onPage={setPage}
//               />
//             )}
//           </div>

//         </div>
//       </div>

//       <MessageModal message={viewMessage} onClose={() => setViewMessage(null)} />
//     </>
//   );
// };

// export default SmsReports;









import React, { useState, useEffect, useCallback, useRef } from "react";
import { message as antMessage } from "antd";
import { getAccessToken } from "../../token";
import { API_URL } from "../../Constants";

// ─── Utility Functions ──────────────────────────────────────────────────────── 

const formatDate = (dateInput) => {
  if (!dateInput) return "—";
  if (Array.isArray(dateInput)) {
    const [year, month, day, hour = 0, minute = 0, second = 0] = dateInput;
    return new Date(year, month - 1, day, hour, minute, second).toLocaleString("en-US", {
      month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true,
    });
  }
  return new Date(dateInput).toLocaleString("en-US", {
    month: "short", day: "numeric", hour: "numeric", minute: "2-digit", hour12: true,
  });
};

const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return "0.00";
  return new Intl.NumberFormat("en-IN", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(amount / 1000);
};

const getUserIdFromToken = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.userId || payload.sub || payload.id || null;
  } catch {
    return null;
  }
};

// ─── Icons ──────────────────────────────────────────────────────────────────── 

const Icon = {
  Search: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  Filter: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
  ),
  ChevronLeft: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6" />
    </svg>
  ),
  ChevronRight: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  Refresh: ({ spinning }) => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
      style={{ animation: spinning ? "spin 0.8s linear infinite" : "none" }}>
      <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  ),
  Eye: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Close: () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Copy: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  ),
  Check: () => (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  Inbox: () => (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
      <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </svg>
  ),
  Message: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  Zap: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  ),
  Archive: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
    </svg>
  ),
};

// ─── Status Badge ───────────────────────────────────────────────────────────── 

const STATUS_CONFIG = {
  DELIVERED: { bg: "#d1fae5", text: "#065f46", dot: "#10b981", label: "Delivered" },
  UNDELIVERED: { bg: "#fee2e2", text: "#991b1b", dot: "#ef4444", label: "Undelivered" },
  REJECTED: { bg: "#fee2e2", text: "#991b1b", dot: "#ef4444", label: "Rejected" },
  FAILED: { bg: "#fee2e2", text: "#991b1b", dot: "#ef4444", label: "Failed" },
  EXPIRED: { bg: "#ffedd5", text: "#9a3412", dot: "#f97316", label: "Expired" },
  QUEUED: { bg: "#f1f5f9", text: "#475569", dot: "#94a3b8", label: "Queued" },
  SUBMITTED: { bg: "#dbeafe", text: "#1e40af", dot: "#3b82f6", label: "Submitted" },
};

const StatusBadge = ({ status }) => {
  const key = status ? status.toUpperCase() : "UNKNOWN";
  const cfg = STATUS_CONFIG[key] || { bg: "#f3f4f6", text: "#4b5563", dot: "#9ca3af", label: key };
  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: "5px",
      padding: "3px 9px", borderRadius: "999px", fontSize: "11px", fontWeight: 700,
      letterSpacing: "0.04em", background: cfg.bg, color: cfg.text,
      fontFamily: "'DM Sans', sans-serif",
    }}>
      <span style={{ width: 6, height: 6, borderRadius: "50%", background: cfg.dot, flexShrink: 0 }} />
      {cfg.label}
    </span>
  );
};

// ─── Skeleton Rows ──────────────────────────────────────────────────────────── 

const SkeletonRow = ({ delay = 0 }) => (
  <tr style={{ borderBottom: "1px solid #f1f5f9", animation: `fadeIn 0.4s ease ${delay}ms both` }}>
    {[28, 36, 24, 52, 22, 16, 20, 20].map((w, i) => (
      <td key={i} style={{ padding: "14px 20px" }}>
        <div style={{
          height: 11, width: `${w * 4}px`, maxWidth: "100%",
          background: "linear-gradient(90deg, #f1f5f9 25%, #e8edf2 50%, #f1f5f9 75%)",
          backgroundSize: "200% 100%", borderRadius: 6,
          animation: "shimmer 1.6s infinite",
        }} />
      </td>
    ))}
  </tr>
);

// ─── Message Modal ──────────────────────────────────────────────────────────── 

const MessageModal = ({ message, onClose }) => {
  useEffect(() => {
    const handler = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [onClose]);

  if (!message) return null;
  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 1000,
        background: "rgba(15,23,42,0.5)", backdropFilter: "blur(6px)",
        display: "flex", alignItems: "center", justifyContent: "center", padding: 24,
        animation: "fadeIn 0.15s ease",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#F0EFEB", borderRadius: 20, boxShadow: "0 24px 64px rgba(0,0,0,0.18)",
          width: "100%", maxWidth: 520, overflow: "hidden",
          animation: "modalIn 0.2s cubic-bezier(0.34,1.56,0.64,1)",
        }}
      >
        <div style={{
          padding: "18px 24px", borderBottom: "1px solid #f1f5f9",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          background: "#0C4550",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{
              width: 32, height: 32, borderRadius: 10, background: "#e0f2fe",
              display: "flex", alignItems: "center", justifyContent: "center", color: "#0369a1",
            }}>
              <Icon.Message />
            </div>
            <span style={{ fontWeight: 700, fontSize: 15, color: "#ffffff", fontFamily: "'DM Sans', sans-serif" }}>
              Message Content
            </span>
          </div>
          <button
            onClick={onClose}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#fff",
              padding: 0,
              outline: "none",
            }}
          >
            <Icon.Close />
          </button>
        </div>
        <div style={{ padding: 24 }}>
          <div style={{
            background: "#f8fafc", borderRadius: 12, border: "1px solid #e2e8f0",
            padding: "16px 20px", color: "#334155", fontSize: 14, lineHeight: 1.7,
            whiteSpace: "pre-wrap", fontFamily: "ui-monospace, 'Cascadia Code', monospace",
            minHeight: 80,
          }}>
            {message}
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
            <button
              onClick={() => { navigator.clipboard.writeText(message); antMessage.success("Copied!"); }}
              style={{
                display: "flex", alignItems: "center", gap: 6,
                padding: "8px 16px", borderRadius: 8, border: "1px solid #e2e8f0",
                background: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600,
                color: "#475569", fontFamily: "'DM Sans', sans-serif", transition: "all 0.15s",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "#f8fafc"; e.currentTarget.style.borderColor = "#cbd5e1"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.borderColor = "#e2e8f0"; }}
            >
              <Icon.Copy /> Copy
            </button>
            <button
              onClick={onClose}
              style={{
                padding: "8px 20px", borderRadius: 8, border: "none",
                background: "#0c4550", cursor: "pointer", fontSize: 13, fontWeight: 700,
                color: "#fff", fontFamily: "'DM Sans', sans-serif", transition: "all 0.15s",
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = "#093840"}
              onMouseLeave={(e) => e.currentTarget.style.background = "#0c4550"}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// ─── Copy Button ────────────────────────────────────────────────────────────── 

const CopyButton = ({ text }) => {
  const [copied, setCopied] = useState(false);
  const handle = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    antMessage.success("Copied!");
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <button
      onClick={handle}
      title="Copy"
      style={{
        border: "none", background: "transparent", cursor: "pointer",
        color: copied ? "#10b981" : "#cbd5e1", transition: "color 0.2s",
        padding: 2, display: "flex", alignItems: "center",
      }}
      onMouseEnter={(e) => { if (!copied) e.currentTarget.style.color = "#0ea5e9"; }}
      onMouseLeave={(e) => { if (!copied) e.currentTarget.style.color = "#cbd5e1"; }}
    >
      {copied ? <Icon.Check /> : <Icon.Copy />}
    </button>
  );
};

// ─── Pagination ─────────────────────────────────────────────────────────────── 

const Pagination = ({ page, totalPages, totalItems, pageSize, onPage }) => {
  const from = totalItems === 0 ? 0 : page * pageSize + 1;
  const to = Math.min((page + 1) * pageSize, totalItems);

  const pages = [];
  const range = (lo, hi) => { for (let i = lo; i <= hi; i++) pages.push(i); };
  if (totalPages <= 7) {
    range(0, totalPages - 1);
  } else if (page < 4) {
    range(0, 4); pages.push("…"); pages.push(totalPages - 1);
  } else if (page > totalPages - 5) {
    pages.push(0); pages.push("…"); range(totalPages - 5, totalPages - 1);
  } else {
    pages.push(0); pages.push("…"); range(page - 1, page + 1); pages.push("…"); pages.push(totalPages - 1);
  }

  const btnBase = {
    minWidth: 34, height: 34, borderRadius: 8, border: "1px solid #e2e8f0",
    background: "#fff", cursor: "pointer", fontSize: 13, fontWeight: 600,
    color: "#64748b", transition: "all 0.15s", display: "flex",
    alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans', sans-serif",
    padding: "0 8px",
  };

  return (
    <div style={{
      padding: "14px 20px", borderTop: "1px solid #f1f5f9", background: "#fafafa",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      flexWrap: "wrap", gap: 12,
    }}>
      <span style={{ fontSize: 13, color: "#64748b", fontFamily: "'DM Sans', sans-serif" }}>
        Showing <strong style={{ color: "#0f172a" }}>{from}</strong>–<strong style={{ color: "#0f172a" }}>{to}</strong> of{" "}
        <strong style={{ color: "#0f172a" }}>{totalItems.toLocaleString()}</strong> records
      </span>
      <div style={{ display: "flex", gap: 4 }}>
        <button
          onClick={() => onPage(page - 1)} disabled={page === 0}
          style={{ ...btnBase, opacity: page === 0 ? 0.4 : 1, cursor: page === 0 ? "not-allowed" : "pointer" }}
          onMouseEnter={(e) => { if (page !== 0) e.currentTarget.style.background = "#f8fafc"; }}
          onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}
        >
          <Icon.ChevronLeft />
        </button>
        {pages.map((p, i) =>
          p === "…" ? (
            <span key={`e${i}`} style={{ ...btnBase, border: "none", background: "transparent", cursor: "default" }}>…</span>
          ) : (
            <button
              key={p} onClick={() => onPage(p)}
              style={{
                ...btnBase,
                background: p === page ? "#0c4550" : "#fff",
                color: p === page ? "#fff" : "#64748b",
                borderColor: p === page ? "#0c4550" : "#e2e8f0",
              }}
              onMouseEnter={(e) => { if (p !== page) e.currentTarget.style.background = "#f8fafc"; }}
              onMouseLeave={(e) => { if (p !== page) e.currentTarget.style.background = "#fff"; }}
            >
              {p + 1}
            </button>
          )
        )}
        <button
          onClick={() => onPage(page + 1)} disabled={page >= totalPages - 1 || totalPages === 0}
          style={{ ...btnBase, opacity: (page >= totalPages - 1 || totalPages === 0) ? 0.4 : 1, cursor: (page >= totalPages - 1 || totalPages === 0) ? "not-allowed" : "pointer" }}
          onMouseEnter={(e) => { if (!(page >= totalPages - 1 || totalPages === 0)) e.currentTarget.style.background = "#f8fafc"; }}
          onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}
        >
          <Icon.ChevronRight />
        </button>
      </div>
    </div>
  );
};

// ─── Main Component ─────────────────────────────────────────────────────────── 

export const SmsReports = () => {
  const token = getAccessToken();

  // ── Archive link visibility ───────────────────────────────────────────────── 
  const ARCHIVE_USER_ID = "69fedd52b0538a771d9d6387";
  const showArchiveLink = getUserIdFromToken(token) === ARCHIVE_USER_ID;

  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [viewMessage, setViewMessage] = useState(null);
  const [reportType, setReportType] = useState("single");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const pageSize = 20;
  const KEYSET_THRESHOLD = 200;
  const lastSentAtCursor = useRef(null);

  const [filters, setFilters] = useState({
    mobile: "", senderId: "", status: "", startDate: "", endDate: "",
  });
  const pendingFilters = useRef({ ...filters });

  // ── Fetch ────────────────────────────────────────────────────────────────── 

  const fetchReports = useCallback(async (opts = {}) => {
    setLoading(true);
    const activeFilters = opts.filters || pendingFilters.current;
    const activePage = opts.page !== undefined ? opts.page : page;

    try {
      const params = new URLSearchParams({ page: activePage, size: pageSize });
      if (activeFilters.mobile) params.set("mobile", activeFilters.mobile);
      if (activeFilters.senderId) params.set("senderId", activeFilters.senderId);
      if (activeFilters.status) params.set("status", activeFilters.status);
      if (activeFilters.startDate) params.set("startDate", activeFilters.startDate);
      if (activeFilters.endDate) params.set("endDate", activeFilters.endDate);

      if (activePage >= KEYSET_THRESHOLD && lastSentAtCursor.current) {
        params.set("lastSentAt", lastSentAtCursor.current);
      }

      const endpoint = reportType === "single"
        ? `/api/reports/single`
        : `/api/reports/bulk`;

      const res = await fetch(`${API_URL}${endpoint}?${params}`, {
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      const records = data.content ?? [];
      setLogs(records);
      setTotalPages(data.totalPages ?? 0);
      setTotalItems(data.totalElements ?? 0);

      if (records.length > 0) {
        const last = records[records.length - 1];
        lastSentAtCursor.current = Array.isArray(last.submittedAt)
          ? new Date(...last.submittedAt.map((v, i) => i === 1 ? v - 1 : v)).toISOString()
          : last.submittedAt;
      }
    } catch (err) {
      antMessage.error(`Could not load ${reportType} reports. Please try again.`);
      setLogs([]);
    } finally {
      setLoading(false);
      setFirstLoad(false);
    }
  }, [reportType, page, token]);

  useEffect(() => { fetchReports(); }, [page, reportType]);

  // ── Handlers ─────────────────────────────────────────────────────────────── 

  const handleTabChange = (type) => {
    if (type === reportType) return;
    lastSentAtCursor.current = null;
    setReportType(type);
    setPage(0);
    setLogs([]);
    setFirstLoad(true);
  };

  const handleFilterChange = (e) => {
    const next = { ...pendingFilters.current, [e.target.name]: e.target.value };
    pendingFilters.current = next;
    setFilters(next);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    lastSentAtCursor.current = null;
    setPage(0);
    fetchReports({ page: 0, filters: pendingFilters.current });
  };

  const handleClearFilters = () => {
    const empty = { mobile: "", senderId: "", status: "", startDate: "", endDate: "" };
    pendingFilters.current = empty;
    lastSentAtCursor.current = null;
    setFilters(empty);
    setPage(0);
    fetchReports({ page: 0, filters: empty });
  };

  const hasActiveFilters = Object.values(filters).some(Boolean);

  // ── Styles ───────────────────────────────────────────────────────────────── 

  const inputStyle = {
    width: "100%", height: 40, padding: "0 12px", fontSize: 13,
    border: "1px solid #e2e8f0", borderRadius: 10, background: "#fff",
    color: "#334155", outline: "none", fontFamily: "'DM Sans', sans-serif",
    boxSizing: "border-box", transition: "border-color 0.15s, box-shadow 0.15s",
  };

  const labelStyle = {
    fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.07em",
    textTransform: "uppercase", marginBottom: 5, display: "block",
    fontFamily: "'DM Sans', sans-serif",
  };

  // ── Render ───────────────────────────────────────────────────────────────── 

  return (
    <>
      <style>{` 
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&display=swap'); 
        @keyframes fadeIn { from { opacity:0; transform:translateY(6px); } to { opacity:1; transform:translateY(0); } } 
        @keyframes modalIn { from { opacity:0; transform:scale(0.94) translateY(10px); } to { opacity:1; transform:scale(1) translateY(0); } } 
        @keyframes spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } } 
        @keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} } 
        @keyframes slideIn { from { opacity:0; transform:translateX(-8px); } to { opacity:1; transform:translateX(0); } } 
        .report-row { transition: background 0.12s; } 
        .report-row:hover { background: #f0f9ff !important; } 
        .report-row:hover .eye-btn { opacity: 1 !important; } 
        .report-row:hover .copy-zone { opacity: 1 !important; } 
        .filter-input:focus { border-color: #0c4550 !important; box-shadow: 0 0 0 3px rgba(12,69,80,0.08) !important; } 
        .filter-input:hover { border-color: #94a3b8 !important; } 
        select.filter-input { appearance: none; cursor: pointer; } 
      `}</style>

      <div style={{
        minHeight: "100vh", background: "#f0efeb", padding: "28px 24px",
        fontFamily: "'DM Sans', sans-serif",
      }}>
        <div style={{ maxWidth: 1400, margin: "0 auto" }}>

          {/* ── Header ── */}
          <div style={{
            display: "flex", justifyContent: "space-between", alignItems: "flex-start",
            flexWrap: "wrap", gap: 16, marginBottom: 24,
            animation: "fadeIn 0.4s ease",
          }}>
            <div>
              <h1 style={{
                fontSize: 26, fontWeight: 700, color: "#0f172a", margin: 0,
                letterSpacing: "-0.02em",
              }}>
                Delivery Reports
              </h1>
              <p style={{ margin: "4px 0 0", fontSize: 14, color: "#64748b" }}>
                Track and analyze your SMS delivery performance
              </p>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              {/* Tab Toggle */}
              <div style={{
                display: "flex", gap: "8px", background: "rgba(255, 255, 255, 0.6)",
                padding: "6px", borderRadius: "12px", border: "1px solid #fff",
                boxShadow: "0 1px 2px rgba(0,0,0,0.05)", width: "fit-content"
              }}>
                {[
                  { key: "single", label: "Single Messages", icon: <Icon.Message /> },
                  { key: "bulk", label: "Bulk Messages", icon: <Icon.Zap /> },
                ].map(({ key, label, icon }) => {
                  const active = reportType === key;
                  return (
                    <button
                      key={key}
                      onClick={() => handleTabChange(key)}
                      style={{
                        display: "flex", alignItems: "center", gap: "8px",
                        padding: "8px 20px", borderRadius: "8px", border: "none", cursor: "pointer",
                        fontSize: "14px", fontWeight: 700, fontFamily: "'DM Sans', sans-serif",
                        transition: "all 0.3s ease",
                        background: active ? "#0C4550" : "transparent",
                        color: active ? "#fff" : "#0C4550",
                        boxShadow: active ? "0 4px 6px rgba(0,0,0,0.1)" : "none",
                      }}
                      onMouseEnter={(e) => {
                        if (!active) e.currentTarget.style.background = "rgba(12, 69, 80, 0.1)";
                      }}
                      onMouseLeave={(e) => {
                        if (!active) e.currentTarget.style.background = "transparent";
                      }}
                    >
                      <span style={{ display: "flex", alignItems: "center" }}>{icon}</span>
                      {label}
                    </button>
                  );
                })}
              </div>

              {/* ── Older Records Link — visible only for authorised userId ── */}
              {showArchiveLink && (
                <a
                  href="https://deetyasoft-my.sharepoint.com/:f:/p/raman/IgClYA8pY4i0T7boq11BuaXMAYv1UQLtoZvED1wdFsoEPzw?e=8cFDo4"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-flex", alignItems: "center", gap: 6,
                    height: 38, padding: "0 14px", borderRadius: 10,
                    border: "1px solid #e2e8f0", background: "#fff",
                    color: "#0c4550", fontSize: 13, fontWeight: 700,
                    textDecoration: "none", fontFamily: "'DM Sans', sans-serif",
                    transition: "all 0.15s", whiteSpace: "nowrap", flexShrink: 0,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = "#e0f2f9";
                    e.currentTarget.style.borderColor = "#0c4550";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "#fff";
                    e.currentTarget.style.borderColor = "#e2e8f0";
                  }}
                >
                  <Icon.Archive />
                  Older Records
                </a>
              )}

              {/* Refresh */}
              <button
                onClick={() => fetchReports()}
                title="Refresh"
                style={{
                  width: 38, height: 38, borderRadius: 10, border: "1px solid #e2e8f0",
                  background: "#fff", cursor: "pointer", display: "flex", alignItems: "center",
                  justifyContent: "center", color: loading ? "#0c4550" : "#64748b",
                  transition: "all 0.15s", flexShrink: 0,
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = "#f8fafc"; e.currentTarget.style.borderColor = "#cbd5e1"; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.borderColor = "#e2e8f0"; }}
              >
                <Icon.Refresh spinning={loading} />
              </button>
            </div>
          </div>

          {/* ── Filters Panel ── */}
          <div style={{
            background: "#fff", borderRadius: 16, border: "1px solid #e8e6e0",
            padding: "18px 20px", marginBottom: 20,
            animation: "fadeIn 0.4s ease 0.05s both",
          }}>
            <div style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              marginBottom: 14, paddingBottom: 12, borderBottom: "1px solid #f8fafc",
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <div style={{
                  width: 28, height: 28, borderRadius: 8, background: "#e0f2f9",
                  display: "flex", alignItems: "center", justifyContent: "center", color: "#0c4550",
                }}>
                  <Icon.Filter />
                </div>
                <span style={{ fontWeight: 700, fontSize: 12, color: "#475569", letterSpacing: "0.07em", textTransform: "uppercase" }}>
                  Filter {reportType === "single" ? "Single" : "Bulk"} Records
                </span>
              </div>
              {hasActiveFilters && (
                <button
                  onClick={handleClearFilters}
                  style={{
                    fontSize: 12, fontWeight: 600, color: "#94a3b8", background: "none",
                    border: "none", cursor: "pointer", display: "flex", alignItems: "center",
                    gap: 4, padding: "3px 8px", borderRadius: 6, transition: "all 0.15s",
                    fontFamily: "'DM Sans', sans-serif",
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.color = "#ef4444"; e.currentTarget.style.background = "#fef2f2"; }}
                  onMouseLeave={(e) => { e.currentTarget.style.color = "#94a3b8"; e.currentTarget.style.background = "none"; }}
                >
                  <Icon.Close /> Clear filters
                </button>
              )}
            </div>

            <form onSubmit={handleSearch}>
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
                gap: 14, alignItems: "end",
              }}>
                {/* 1. Delivery Status */}
                <div style={{ position: "relative" }}>
                  <label style={labelStyle}>Delivery Status</label>
                  <div style={{ position: "relative" }}>
                    <select
                      name="status" value={filters.status} onChange={handleFilterChange}
                      className="filter-input" style={{ ...inputStyle, paddingRight: 30 }}
                      onFocus={(e) => { e.target.style.borderColor = "#0c4550"; e.target.style.boxShadow = "0 0 0 3px rgba(12,69,80,0.08)"; }}
                      onBlur={(e) => { e.target.style.borderColor = "#e2e8f0"; e.target.style.boxShadow = "none"; }}
                    >
                      <option value="">All Statuses</option>
                      <option value="DELIVERED">Delivered</option>
                      <option value="UNDELIVERED">Undelivered</option>
                      <option value="FAILED">Failed</option>
                    </select>
                    <span style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", pointerEvents: "none" }}>
                      <Icon.ChevronRight />
                    </span>
                  </div>
                </div>

                {/* 2. Mobile Number */}
                <div style={{ position: "relative" }}>
                  <label style={labelStyle}>Mobile Number</label>
                  <div style={{ position: "relative" }}>
                    <span style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "#94a3b8", pointerEvents: "none", display: "flex" }}>
                      <Icon.Search />
                    </span>
                    <input
                      type="text" name="mobile" placeholder="e.g. 9876543210"
                      value={filters.mobile} onChange={handleFilterChange}
                      className="filter-input"
                      style={{ ...inputStyle, paddingLeft: 34 }}
                      onFocus={(e) => { e.target.style.borderColor = "#0c4550"; e.target.style.boxShadow = "0 0 0 3px rgba(12,69,80,0.08)"; }}
                      onBlur={(e) => { e.target.style.borderColor = "#e2e8f0"; e.target.style.boxShadow = "none"; }}
                    />
                  </div>
                </div>

                {/* 3. Sender ID */}
                <div>
                  <label style={labelStyle}>Sender ID</label>
                  <input
                    type="text" name="senderId" placeholder="e.g. ALERTS"
                    value={filters.senderId} onChange={handleFilterChange}
                    className="filter-input" style={inputStyle}
                    onFocus={(e) => { e.target.style.borderColor = "#0c4550"; e.target.style.boxShadow = "0 0 0 3px rgba(12,69,80,0.08)"; }}
                    onBlur={(e) => { e.target.style.borderColor = "#e2e8f0"; e.target.style.boxShadow = "none"; }}
                  />
                </div>

                {/* 4. Date Range */}
                <div style={{ gridColumn: "span 2", minWidth: 0 }}>
                  <label style={labelStyle}>Date Range</label>
                  <div style={{
                    display: "flex", alignItems: "center", gap: 6,
                    height: 40, border: "1px solid #e2e8f0", borderRadius: 10,
                    background: "#fff", overflow: "hidden", padding: "0 4px",
                    transition: "border-color 0.15s", boxSizing: "border-box",
                  }}
                    onFocusCapture={(e) => e.currentTarget.style.borderColor = "#0c4550"}
                    onBlurCapture={(e) => e.currentTarget.style.borderColor = "#e2e8f0"}
                  >
                    <input type="date" name="startDate" value={filters.startDate} onChange={handleFilterChange}
                      style={{ flex: 1, border: "none", outline: "none", fontSize: 12, color: "#334155", background: "transparent", fontFamily: "'DM Sans', sans-serif", minWidth: 0 }} />
                    <span style={{ color: "#cbd5e1", fontSize: 11, fontWeight: 600, flexShrink: 0 }}>to</span>
                    <input type="date" name="endDate" value={filters.endDate} onChange={handleFilterChange}
                      style={{ flex: 1, border: "none", outline: "none", fontSize: 12, color: "#334155", background: "transparent", fontFamily: "'DM Sans', sans-serif", minWidth: 0 }} />
                  </div>
                </div>

                {/* 5. Apply */}
                <div>
                  <button
                    type="submit" disabled={loading}
                    style={{
                      width: "100%", height: 40, border: "none", borderRadius: 10,
                      background: loading ? "#94a3b8" : "#0c4550", color: "#fff",
                      fontSize: 13, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer",
                      fontFamily: "'DM Sans', sans-serif", transition: "all 0.15s",
                      display: "flex", alignItems: "center", justifyContent: "center", gap: 6,
                    }}
                    onMouseEnter={(e) => { if (!loading) e.currentTarget.style.background = "#093840"; }}
                    onMouseLeave={(e) => { if (!loading) e.currentTarget.style.background = "#0c4550"; }}
                  >
                    {loading
                      ? <div style={{ width: 14, height: 14, borderRadius: "50%", border: "2px solid rgba(255,255,255,0.3)", borderTopColor: "#fff", animation: "spin 0.7s linear infinite" }} />
                      : <><Icon.Search /> Apply</>
                    }
                  </button>
                </div>
              </div>
            </form>
          </div>

          {/* ── Table Card ── */}
          <div style={{
            background: "#fff", borderRadius: 16, border: "1px solid #e8e6e0",
            overflow: "hidden", animation: "fadeIn 0.4s ease 0.1s both",
          }}>
            <div style={{
              padding: "14px 20px 12px", borderBottom: "1px solid #f1f5f9",
              display: "flex", alignItems: "center", justifyContent: "space-between",
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{
                  display: "inline-flex", alignItems: "center", gap: 5,
                  padding: "3px 10px", borderRadius: 999, fontSize: 11, fontWeight: 700,
                  background: reportType === "single" ? "#e0f2fe" : "#fef9c3",
                  color: reportType === "single" ? "#0369a1" : "#854d0e",
                }}>
                  <span style={{
                    width: 6, height: 6, borderRadius: "50%",
                    background: reportType === "single" ? "#0ea5e9" : "#eab308",
                  }} />
                  {reportType === "single" ? "Single Messages" : "Bulk Messages"}
                </span>
                {!loading && (
                  <span style={{ fontSize: 12, color: "#94a3b8", fontWeight: 500 }}>
                    {totalItems.toLocaleString()} records
                  </span>
                )}
              </div>
            </div>

            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 840 }}>
                <thead>
                  <tr style={{ background: "#f8fafc", borderBottom: "1px solid #f1f5f9" }}>
                    {["Submitted At", "Message ID", "Recipient", "Content", "Status", "Cost (₹)", "Refund (₹)"].map((h, i) => (
                      <th key={h} style={{
                        padding: "11px 20px", textAlign: (i >= 5) ? "right" : "left",
                        fontSize: 11, fontWeight: 700, color: "#94a3b8",
                        letterSpacing: "0.07em", textTransform: "uppercase",
                        whiteSpace: "nowrap", fontFamily: "'DM Sans', sans-serif",
                      }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    [...Array(8)].map((_, i) => <SkeletonRow key={i} delay={i * 40} />)
                  ) : logs.length === 0 ? (
                    <tr>
                      <td colSpan={7} style={{ padding: "72px 20px", textAlign: "center" }}>
                        <div style={{
                          width: 64, height: 64, borderRadius: "50%", background: "#f1f5f9",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          margin: "0 auto 16px", color: "#cbd5e1",
                        }}>
                          <Icon.Inbox />
                        </div>
                        <p style={{ fontWeight: 700, fontSize: 16, color: "#334155", margin: "0 0 4px" }}>
                          No records found
                        </p>
                        <p style={{ fontSize: 13, color: "#94a3b8", margin: 0 }}>
                          {hasActiveFilters ? "Try adjusting your filters." : "No messages to show yet."}
                        </p>
                      </td>
                    </tr>
                  ) : (
                    logs.map((log, idx) => (
                      <tr
                        key={log.messageId || idx}
                        className="report-row"
                        style={{
                          borderBottom: "1px solid #f8fafc",
                          animation: `slideIn 0.25s ease ${Math.min(idx, 10) * 30}ms both`,
                        }}
                      >
                        <td style={{ padding: "13px 20px", whiteSpace: "nowrap" }}>
                          <span style={{ fontSize: 12, color: "#64748b", fontWeight: 500 }}>
                            {formatDate(log.submittedAt)}
                          </span>
                        </td>
                        <td style={{ padding: "13px 20px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <span style={{
                              fontSize: 11, fontFamily: "ui-monospace, monospace",
                              background: "#f8fafc", border: "1px solid #e2e8f0",
                              borderRadius: 6, padding: "3px 7px", color: "#475569",
                              maxWidth: 110, overflow: "hidden", textOverflow: "ellipsis",
                              whiteSpace: "nowrap", display: "block",
                            }} title={log.messageId}>
                              {log.messageId || "—"}
                            </span>
                            {log.messageId && (
                              <span className="copy-zone" style={{ opacity: 0, transition: "opacity 0.15s" }}>
                                <CopyButton text={log.messageId} />
                              </span>
                            )}
                          </div>
                        </td>
                        <td style={{ padding: "13px 20px", whiteSpace: "nowrap" }}>
                          <span style={{ fontSize: 13, fontWeight: 600, color: "#1e293b" }}>
                            {log.recipient || "—"}
                          </span>
                        </td>
                        <td style={{ padding: "13px 20px", maxWidth: 260 }}>
                          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <span style={{
                              fontSize: 13, color: "#475569", overflow: "hidden",
                              textOverflow: "ellipsis", whiteSpace: "nowrap", flex: 1,
                              minWidth: 0,
                            }} title={log.content}>
                              {log.content || <span style={{ color: "#cbd5e1" }}>—</span>}
                            </span>
                            {log.content && (
                              <button
                                className="eye-btn"
                                onClick={() => setViewMessage(log.content)}
                                title="View full message"
                                style={{
                                  opacity: 0, transition: "opacity 0.15s",
                                  border: "1px solid #e2e8f0", borderRadius: 7, background: "#fff",
                                  width: 26, height: 26, display: "flex", alignItems: "center",
                                  justifyContent: "center", cursor: "pointer", flexShrink: 0,
                                  color: "#64748b",
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.background = "#e0f2fe"; e.currentTarget.style.color = "#0369a1"; e.currentTarget.style.borderColor = "#bae6fd"; }}
                                onMouseLeave={(e) => { e.currentTarget.style.background = "#fff"; e.currentTarget.style.color = "#64748b"; e.currentTarget.style.borderColor = "#e2e8f0"; }}
                              >
                                <Icon.Eye />
                              </button>
                            )}
                          </div>
                        </td>
                        <td style={{ padding: "13px 20px", whiteSpace: "nowrap" }}>
                          <StatusBadge status={log.detailedStatus} />
                        </td>
                        {/* <td style={{ padding: "13px 20px", whiteSpace: "nowrap" }}>
                          {log.errorCode
                            ? <span style={{ fontSize: 11, fontFamily: "ui-monospace, monospace", color: "#ef4444", background: "#fef2f2", padding: "2px 6px", borderRadius: 5, border: "1px solid #fecaca" }}>
                              {log.errorCode}
                            </span>
                            : <span style={{ color: "#e2e8f0", fontSize: 12 }}>—</span>
                          }
                        </td> */}
                        <td style={{ padding: "13px 20px", textAlign: "right", whiteSpace: "nowrap" }}>
                          <span style={{ fontSize: 13, fontFamily: "ui-monospace, monospace", color: "#334155", fontWeight: 600 }}>
                            {formatCurrency(log.cost)}
                          </span>
                        </td>
                        <td style={{ padding: "13px 20px", textAlign: "right", whiteSpace: "nowrap" }}>
                          {log.refundedAmount > 0 ? (
                            <span style={{ fontSize: 13, fontFamily: "ui-monospace, monospace", color: "#10b981", fontWeight: 700 }}>
                              +{formatCurrency(log.refundedAmount)}
                            </span>
                          ) : (
                            <span style={{ fontSize: 13, fontFamily: "ui-monospace, monospace", color: "#94a3b8" }}>
                              {formatCurrency(0)}
                            </span>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {!loading && totalPages > 0 && (
              <Pagination
                page={page}
                totalPages={totalPages}
                totalItems={totalItems}
                pageSize={pageSize}
                onPage={setPage}
              />
            )}
          </div>

        </div>
      </div>

      <MessageModal message={viewMessage} onClose={() => setViewMessage(null)} />
    </>
  );
};

export default SmsReports;